export class Sprite_TilingFrame extends KDCore.Sprite {
  constructor(_width, _height, skin) {
    super();
    this._width = _width;
    this._height = _height;

    this._createParts();

    this.skinBitmap = ImageManager.loadInv(skin);
    this.skinBitmap.addLoadListener(() => {
      return this._refreshAll();
    });
  }

  _createParts() {
    this.backSprite = new Sprite();
    this.addChild(this.backSprite);

    this.content = new Sprite();
    this.addChild(this.content);

    this.frame = new Sprite();
    for (let i = 0; i < 8; i++) {
      this.frame.addChild(new Sprite());
    }

    this.addChild(this.frame);
  }

  _refreshAll() {
    this._refreshBack();
    this._refreshTFrame();
  }

  _refreshBack() {
    const m = 2; // * Wcięcie, aby nie wychodzić poza ramkę
    const width = Math.max(0, this._width - m * 2);
    const height = Math.max(0, this._height - m * 2);

    const sprite = this.backSprite;
    sprite.bitmap = this.skinBitmap;

    sprite.setFrame(0, 0, 96, 96);
    sprite.move(m, m);
    sprite.scale.x = width / 96;
    sprite.scale.y = height / 96;
  }

  _refreshTFrame() {
    // * Pozycja docelowa
    const drect = {
      x: 0,
      y: 0,
      width: this._width,
      height: this._height
    };

    // * Współrzędne ramy na zdjęciu
    const srect = {
      x: 96,
      y: 0,
      width: 96,
      height: 96
    };

    const m = 12; // * Grubość

    for (let i = 0; i < this.frame.children.length; i++) {
      const spr = this.frame.children[i];
      spr.bitmap = this.skinBitmap;
    }

    Window.prototype._setRectPartsGeometry.call(this, this.frame, srect, drect, m);
  }
}
